import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { extractSelectedTicketFromState } from '../../../extractFromState';
import ShipstationCreateLabel from '../../../components/tools/common/ShipstationCreateLabel/ShipstationCreateLabel';
import { setSelectedTask } from '../../../actions/tools/OrdersSearchActions';
import { getShipstationOrder, createShipstationReturnLabel } from '../../../actions/tools/ShipstationActions';

const mapStateToProps = (state) => ({
  selectedToolDomains: state.tools.general.selectedToolDomains,
  selectedShop: state.tools.ordersSearch.selectedShop,
  selectedConfig: state.tools.ordersSearch.selectedConfig,
  selectedOrder: state.tools.ordersSearch.selectedOrder || {},
  selectedTicket: extractSelectedTicketFromState(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setSelectedTask,
      getShipstationOrder,
      createShipstationReturnLabel,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ShipstationCreateLabel);
